export default {
  title: 'Equipment Form',
  type: 'object',
  properties: {
    dateOfPurchase: {
      type: 'string',
      format: 'date',
      title: 'Data nabycia',
      fieldRequired: 'false'
    },
    invoiceNumber: {
      type: 'string',
      format: 'string',
      title: 'Numer faktury',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Podaj numer faktury'
      }
    },
    name: {
      type: 'string',
      format: 'string',
      title: 'Nazwa wyposażenia',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Wpisz nazwę wyposażenia'
      }
    },
    price: {
      type: 'money',
      format: 'money',
      title: 'Cena nabycia',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Podaj cenę zakupu / wytworzenia'
      }
    },
    positionNumber: {
      type: 'string',
      title: 'Numer pozycji',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Numer pozycji, pod którą wpisano w księdze koszt związany z nabyciem wyposażenia'
      }
    },
    systemNumber: {
      type: 'string',
      title: 'Numer systemowy',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Numer na nalypce'
      }
    },
    deleted: {
      type: 'boolean',
      title: 'Usunięty'
    },
    deleteDate: {
      type: 'string',
      format: 'date',
      title: 'Data likwidacji',
      fieldRequired: 'false'
    },
    deleteReason: {
      type: 'string',
      title: 'Powód likwidacji',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Podaj powód likwidacji'
      }
    },
    annotation: {
      type: 'string',
      title: 'Uwagi',
      fieldRequired: 'false'
    },
    serialNumber: {
      type: 'string',
      title: 'Numer seryjny',
      fieldRequired: 'false'
    },
    type: {
      type: 'number',
      title: 'Typ wyposażenia',
      fieldRequired: 'false'
    }
  }
};
